'use strict';

/**
 * Base class for Wreqr definitions
 *
 * @category   Wreqr
 * @module     base
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.de)
 * @author     Stefan Rueschenberg <sr@humans.am>
 */

var Backbone = require('backbone');
var Marionette = require('backbone-marionette');

var Wreqr = Marionette.Object.extend({
    /**
     * Reference to the channel
     * @type {Backbone.Wreqr.radio.channel}
     */
    channel: null,

    /**
     * Reference to the marionette module
     */
    module: null,

    /**
     * Concat char thath should be used by transforming function names from camelcase to hyphen splitted
     * @type {string}
     */
    functionConcat: ':',

    /**
     * Initializes the class and attaches the handler based on names
     * @param {object} options Options, that were passed be initiating the object
     */
    initialize: function(options) {
        this.channel = Backbone.Wreqr.radio.channel(this.getOption('name'));
        this.module = this.getOption('module');

        _.each(_.functions(this), function(functionName) {
            var cleanName = functionName.replace(/^(command|request|vent)/, '');
            var hyphenName = _.camelToHyphen(cleanName, this.getOption('functionConcat'));

            if (/^command/.test(functionName)) {
                this.channel.commands.setHandler(hyphenName, this[functionName].bind(this));
            } else if (/^request/.test(functionName)) {
                this.channel.reqres.setHandler(hyphenName, this[functionName].bind(this));
            } else if (/^vent/.test(functionName)) {
                this.channel.vent.on(hyphenName, this[functionName].bind(this));
            }
        }.bind(this));
    },

    /**
     * Deattaches all handlers from the wreqr and stop listing to directly attached listeners
     */
    destroy: function() {
        this.channel.commands.removeAllHandlers();
        this.channel.reqres.removeAllHandlers();
        this.channel.vent.off();

        Marionette.Object.prototype.destroy.apply(this, arguments);
    },
});

module.exports = Wreqr;